//#region src/loyalty_post_auth_steps.ts
var LoyaltyPostAuthStep = /* @__PURE__ */ function(LoyaltyPostAuthStep) {
	LoyaltyPostAuthStep["Exit"] = "exit";
	LoyaltyPostAuthStep["Rewards"] = "rewards";
	LoyaltyPostAuthStep["OrderHistory"] = "order-history";
	return LoyaltyPostAuthStep;
}(LoyaltyPostAuthStep || {});
//#endregion
export { LoyaltyPostAuthStep };

//# sourceMappingURL=loyalty_post_auth_steps.js.map